import React from 'react';
import { ArrowLeft, Download, Printer, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { A4Frame } from '../../components/notice/A4Frame';
import { SecureNotice } from '../../components/notice/SecureNotice';
import { noticeMeta } from '../../data/sampleCase';
export function OfficialNoticeViewer() {
  const navigate = useNavigate();
  return <div className="mx-auto max-w-5xl px-4 py-8" data-id="element-2063" data-mp="j68f5yl7ngrh">
      <div className="no-print mb-4 flex flex-wrap items-center justify-between gap-3" data-id="element-2064" data-mp="j5giekfvnczm">
        <div data-id="element-2065" data-mp="e86tr70bb5cu">
          <h1 className="text-2xl font-bold text-[#003B71]" data-id="element-2066" data-mp="e7nanmyxeax8">অফিসিয়াল ডিএমপি নোটিশ</h1>
          <p className="flex items-center gap-1.5 text-sm text-[#16834A]" data-id="element-2067" data-mp="99dfhcd7babm"><ShieldCheck className="h-4 w-4" data-id="element-2068" data-mp="48ppmu0pkziz" /> ডিজিটালি স্বাক্ষরিত • {noticeMeta.documentId}</p>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-2069" data-mp="6ug528mjfu4">
          <Button variant="outline" onClick={() => navigate(-1)} data-id="element-2070" data-mp="85t9snylzxw"><ArrowLeft className="h-4 w-4" data-id="element-2071" data-mp="lfx8f3ozv1ro" /> পূর্ববর্তী পেজে ফিরে যান</Button>
          <Button variant="outline" onClick={() => window.print()} data-id="element-2072" data-mp="q75fvu6rkd27"><Printer className="h-4 w-4" data-id="element-2073" data-mp="q8qafjt2vw02" /> প্রিন্ট</Button>
          <Button onClick={() => {
          toast.success('PDF ডাউনলোড শুরু হয়েছে', {
            description: `${noticeMeta.documentId}.pdf`
          });
          window.print();
        }} data-id="element-2074" data-mp="bire7ml32un8"><Download className="h-4 w-4" data-id="element-2075" data-mp="gi41u9js45qv" /> PDF ডাউনলোড</Button>
        </div>
      </div>
      <div className="rounded-xl bg-slate-200/70 p-3 md:p-6" data-id="element-2076" data-mp="147yeaq06rsal">
        <div className="mx-auto max-w-[794px] shadow-xl" data-id="element-2077" data-mp="195zxdaxm3rm2">
          <A4Frame data-id="element-2078" data-mp="195hs5osz2320"><SecureNotice data-id="element-2079" data-mp="195878fmsam36" /></A4Frame>
        </div>
      </div>
    </div>;
}